/* HS Activa Neubau: Kern. Klassisches Script (defer), keine Abhängigkeiten. */
const PUB_SUB_EVENTS = { cartUpdate: 'cart-update', cartAdd: 'cart-add', cartError: 'cart-error', variantChange: 'variant-change', quantityUpdate: 'quantity-update', siteLoaded: 'site-loaded' };
const __subs = {};
function subscribe(ev, cb) { (__subs[ev] = __subs[ev] || []).push(cb); return () => { __subs[ev] = (__subs[ev] || []).filter((f) => f !== cb); }; }
function publish(ev, data) { (__subs[ev] || []).forEach((cb) => { try { cb(data); } catch (e) { console.error(e); } }); }

const HS = {
  money(cents) {
    const fmt = (window.settings && window.settings.moneyFormat) || '{{amount_with_comma_separator}}€';
    const n = (cents / 100).toFixed(2);
    const [i, d] = n.split('.');
    const withDots = i.replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    let out;
    if (/amount_no_decimals/.test(fmt)) out = withDots;
    else if (/amount_with_comma_separator/.test(fmt)) out = withDots + ',' + d;
    else out = i.replace(/\B(?=(\d{3})+(?!\d))/g, ',') + '.' + d;
    return fmt.replace(/\{\{\s*amount[a-z_]*\s*\}\}/, out);
  },
  lock(on) { document.documentElement.classList.toggle('scroll-lock', on); },
  /* Scroll-Sperre an den Zustand eines <dialog> koppeln. Nicht nur auf "close" hören: in manchen
     Chromium-Builds kam das Ereignis nicht an, und die Seite blieb nach dem Schließen gesperrt
     (Rundgang 23.09.2026). Deshalb zusätzlich "toggle" und das open-Attribut beobachten. */
  watchDialog(d) {
    if (d._hsWatched) return; d._hsWatched = true;
    const sync = () => HS.lock(!!d.open);
    d.addEventListener('close', sync);
    d.addEventListener('toggle', sync);
    d.addEventListener('cancel', () => setTimeout(sync, 0));
    if ('MutationObserver' in window) new MutationObserver(sync).observe(d, { attributes: true, attributeFilter: ['open'] });
  },
  trap(el) {
    const f = el.querySelectorAll('a[href],button:not([disabled]),input:not([disabled]),select,textarea,[tabindex]:not([tabindex="-1"])');
    if (f.length) f[0].focus({ preventScroll: true });
  },
  sectionHTML(html, sel) { const d = new DOMParser().parseFromString(html, 'text/html'); const el = d.querySelector(sel); return el ? el.innerHTML : null; },
  sectionEl(html, sel) { const d = new DOMParser().parseFromString(html, 'text/html'); return d.querySelector(sel); },
  async cartRequest(url, body) {
    const r = await fetch(url, { method: 'POST', headers: { Accept: 'application/javascript', 'X-Requested-With': 'XMLHttpRequest' }, body });
    const j = await r.json().catch(() => ({}));
    if (!r.ok) throw Object.assign(new Error(j.description || j.message || 'Fehler'), { data: j });
    return j;
  },
  cartSections() { return ['cart-drawer', 'cart-icon-bubble'].concat(document.querySelector('cart-items[data-page]') ? ['main-cart'] : []); },
  async addToCart(formData, source) {
    if (!formData.has('sections')) formData.append('sections', HS.cartSections().join(','));
    if (!formData.has('sections_url')) formData.append('sections_url', window.location.pathname);
    const data = await HS.cartRequest(window.routes.cart_add_url, formData);
    HS.renderCart(data);
    publish(PUB_SUB_EVENTS.cartUpdate, { source: source || 'product-form', productVariantId: formData.get('id'), cartData: data });
    return data;
  },
  renderCart(data) {
    const d = document.querySelector('cart-drawer');
    if (d && data.sections) d.renderContents(data);
    const cp = document.querySelector('cart-items[data-page]');
    if (cp && data.sections && data.sections['main-cart']) cp.renderPage(data.sections['main-cart']);
  },
  async refreshCart() {
    const ids = HS.cartSections();
    const r = await fetch(`${window.location.pathname}?sections=${ids.join(',')}`);
    const sections = await r.json();
    HS.renderCart({ sections });
  }
};
window.HS = HS;

/* Drawer-Basis */
class HSDrawer extends HTMLElement {
  connectedCallback() {
    this.querySelectorAll('[data-close]').forEach((b) => b.addEventListener('click', () => this.close()));
    const ov = this.querySelector('.drawer__overlay');
    if (ov) ov.addEventListener('click', () => this.close());
    this.addEventListener('keydown', (e) => { if (e.key === 'Escape') this.close(); });
    /* Link im Drawer (z. B. „Alle Produkte ansehen" im leeren Warenkorb): Drawer sofort schließen.
       Zeigt der Link auf die aktuelle Seite, würde der Page Loader den Klick schlucken; dann nur schließen und nach oben. */
    this.addEventListener('click', (e) => {
      const a = e.target.closest('a[href]');
      if (!a || a.hasAttribute('data-close') || a.target === '_blank') return;
      if (a.href.split('#')[0] === location.href.split('#')[0]) { e.preventDefault(); this.close(); window.scrollTo({ top: 0 }); return; }
      this.close();
    });
    /* Page Loader tauscht nur den Inhalt: offene Drawer nach der Navigation schließen */
    document.addEventListener('pageloader:loaded', () => { if (this.classList.contains('active')) { this._trigger = null; this.close(); } });
  }
  open(trigger) {
    this._trigger = trigger || document.activeElement;
    document.querySelectorAll('.drawer.active').forEach((d) => { if (d !== this && d.close) d.close(true); });
    this.classList.add('active');
    this.setAttribute('aria-hidden', 'false');
    HS.lock(true);
    setTimeout(() => HS.trap(this.querySelector('.drawer__panel') || this), 60);
    this.dispatchEvent(new CustomEvent('drawer:open', { bubbles: true }));
  }
  close(silent) {
    if (!this.classList.contains('active')) return;
    this.classList.remove('active');
    this.setAttribute('aria-hidden', 'true');
    if (!silent) HS.lock(false);
    if (this._trigger && this._trigger.focus && !silent) this._trigger.focus({ preventScroll: true });
    this.dispatchEvent(new CustomEvent('drawer:close', { bubbles: true }));
  }
}

/* Header */
class HeaderWrapper extends HTMLElement {
  connectedCallback() {
    this._set();
    if ('ResizeObserver' in window) new ResizeObserver(() => this._set()).observe(this);
    document.addEventListener('click', (e) => {
      this.querySelectorAll('.header__nav details[open]').forEach((d) => { if (!d.contains(e.target)) d.removeAttribute('open'); });
    });
    this.querySelectorAll('.header__nav details').forEach((d) => {
      d.addEventListener('keydown', (e) => { if (e.key === 'Escape') { d.removeAttribute('open'); d.querySelector('summary').focus(); } });
      d.addEventListener('toggle', () => { const s = d.querySelector('summary'); if (s) s.setAttribute('aria-expanded', d.open ? 'true' : 'false'); if (d.open) this.querySelectorAll('.header__nav details[open]').forEach((o) => { if (o !== d) o.removeAttribute('open'); }); });
    });
    /* Klick auf einen Menüpunkt: Panel schließen (Page Loader lädt ohne Reload, sonst bliebe es offen) */
    this.addEventListener('click', (e) => { if (e.target.closest('.header__panel a')) this.closePanels(); });
    window.addEventListener('popstate', () => this.closePanels());
    document.addEventListener('pageloader:loaded', () => this.closePanels());
  }
  closePanels() { this.querySelectorAll('.header__nav details[open]').forEach((d) => d.removeAttribute('open')); if (document.activeElement && this.contains(document.activeElement)) document.activeElement.blur(); }
  _set() { document.documentElement.style.setProperty('--header-real', this.offsetHeight + 'px'); }
}
customElements.define('header-wrapper', HeaderWrapper);

/* Mobilmenü */
class MenuDrawer extends HSDrawer {
  connectedCallback() {
    super.connectedCallback();
    /* Unterpunkte liegen per translateX(100%) rechts neben dem sichtbaren Bereich. Ein focus() ohne
       preventScroll ließ den drawer__body seitlich dorthin scrollen: der Tester sah eine leere weiße
       Fläche („Menü öffnet nicht richtig", 23.09.2026). Deshalb preventScroll und scrollLeft zurück. */
    const body = this.querySelector('.drawer__body');
    const noSideScroll = () => { if (body) body.scrollLeft = 0; };
    this.querySelectorAll('[data-sub]').forEach((b) => b.addEventListener('click', () => {
      const sub = this.querySelector('#' + b.dataset.sub);
      if (sub) { sub.classList.add('is-open'); sub.querySelector('.menu__back').focus({ preventScroll: true }); noSideScroll(); }
    }));
    this.querySelectorAll('.menu__back').forEach((b) => b.addEventListener('click', () => {
      const sub = b.closest('.menu__sub'); sub.classList.remove('is-open');
      const opener = this.querySelector('[data-sub="' + sub.id + '"]'); if (opener) opener.focus({ preventScroll: true }); noSideScroll();
    }));
    if (body) body.addEventListener('scroll', () => { if (body.scrollLeft) body.scrollLeft = 0; }, { passive: true });
  }
  close(s) { super.close(s); this.querySelectorAll('.menu__sub.is-open').forEach((x) => x.classList.remove('is-open')); }
}
customElements.define('menu-drawer', MenuDrawer);

/* Suche */
class SearchDrawer extends HSDrawer {
  open(t) { super.open(t); HS.mountTs(this); setTimeout(() => { const i = this.querySelector('input[type="search"]'); if (i) i.focus(); }, 80); }
}
customElements.define('search-drawer', SearchDrawer);

/* Trusted-Shops-Karussell erst einhängen, wenn es gebraucht wird (sonst ~20 Anfragen auf jeder Seite).
   Im Such-Drawer beim Öffnen, auf der Kategorieseite wenn der Platzhalter in die Nähe kommt. */
HS.mountTs = (scope) => {
  (scope || document).querySelectorAll('[data-ts-widget]').forEach((el) => {
    if (el.dataset.tsMounted) return;
    el.dataset.tsMounted = '1';
    const w = document.createElement('etrusted-widget');
    w.setAttribute('data-etrusted-widget-id', el.dataset.tsWidget);
    el.appendChild(w);
  });
};
HS.watchTs = () => {
  const slots = [...document.querySelectorAll('[data-ts-widget]:not([data-ts-mounted])')].filter((el) => !el.closest('.drawer'));
  if (!slots.length) return;
  if (!('IntersectionObserver' in window)) { slots.forEach((el) => HS.mountTs(el.parentElement)); return; }
  const io = new IntersectionObserver((es) => { es.forEach((e) => { if (e.isIntersecting) { HS.mountTs(e.target.parentElement); io.unobserve(e.target); } }); }, { rootMargin: '400px 0px' });
  slots.forEach((el) => io.observe(el));
};
HS.watchTs();
document.addEventListener('pageloader:loaded', () => HS.watchTs());

class PredictiveSearch extends HTMLElement {
  connectedCallback() {
    this.input = this.querySelector('input[type="search"]');
    this.results = this.querySelector('[data-results]');
    this.all = this.querySelector('[data-all]');
    this.idle = this.querySelector('[data-idle]');
    this.status = this.querySelector('[data-status]');
    this.form = this.querySelector('form');
    this.input.addEventListener('input', () => { clearTimeout(this._t); this._t = setTimeout(() => this.search(), 250); });
    this.form.addEventListener('submit', () => { if (!this.input.value.trim()) event.preventDefault(); });
  }
  async search() {
    const q = this.input.value.trim();
    if (this.all) { this.all.textContent = q ? `Zeige mir alles von "${q}":` : ''; this.all.href = `/search?q=${encodeURIComponent(q)}`; }
    if (q.length < 2) { this.results.innerHTML = ''; if (this.idle) this.idle.hidden = false; return; }
    if (this.idle) this.idle.hidden = true;
    const ctrl = new AbortController(); if (this._ctrl) this._ctrl.abort(); this._ctrl = ctrl;
    try {
      const url = `${window.routes.predictive_search_url}?q=${encodeURIComponent(q)}&resources[type]=product&resources[limit]=6&resources[options][unavailable_products]=hide&section_id=predictive-search`;
      const r = await fetch(url, { signal: ctrl.signal });
      const html = await r.text();
      const inner = HS.sectionHTML(html, '#shopify-section-predictive-search');
      this.results.innerHTML = inner || '';
      const n = this.results.querySelectorAll('.search__result').length;
      if (this.status) this.status.textContent = n ? '' : 'Keine Produkte gefunden. Versuchen Sie ein anderes Wort.';
      publish('hs:search', { term: q, results: n });
    } catch (e) { if (e.name !== 'AbortError') console.error(e); }
  }
}
customElements.define('predictive-search', PredictiveSearch);

/* Warenkorb-Drawer */
class CartDrawer extends HSDrawer {
  connectedCallback() {
    super.connectedCallback();
    const trig = document.getElementById('cart-icon-bubble');
    if (trig) trig.addEventListener('click', (e) => { e.preventDefault(); this.open(trig); });
    this.classList.toggle('is-empty', !this.querySelector('.cart-items tbody tr'));
  }
  renderContents(data) {
    const s = data.sections || {};
    if (s['cart-drawer']) {
      const el = HS.sectionEl(s['cart-drawer'], 'cart-drawer');
      const inner = HS.sectionHTML(s['cart-drawer'], '#CartDrawer');
      if (inner !== null) { this.querySelector('#CartDrawer').innerHTML = inner; }
      if (el) this.classList.toggle('is-empty', el.classList.contains('is-empty'));
    }
    if (s['cart-icon-bubble']) {
      const b = document.getElementById('cart-icon-bubble');
      const nb = HS.sectionEl(s['cart-icon-bubble'], '.cart-count-bubble');
      const ob = b && b.querySelector('.cart-count-bubble');
      if (nb && ob) ob.replaceWith(nb); else if (nb && b) b.appendChild(nb);
    }
    this.querySelector('[data-close]') && this.querySelector('[data-close]').addEventListener('click', () => this.close());
    this.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
    document.dispatchEvent(new CustomEvent('cart:updated'));
  }
}
customElements.define('cart-drawer', CartDrawer);

/* Positionen: Menge ändern, entfernen (Drawer und Seite) */
class CartItems extends HTMLElement {
  connectedCallback() {
    this.addEventListener('change', (e) => { const i = e.target.closest('.quantity__input'); if (i) this.change(i.dataset.index, i.value, i); });
    this.addEventListener('click', (e) => { const b = e.target.closest('cart-remove-button, .cart-remove-button'); if (b) { e.preventDefault(); this.change(b.dataset.index, 0, b); } });
  }
  async change(line, qty, el) {
    this.classList.add('is-busy');
    const body = JSON.stringify({ line, quantity: qty, sections: HS.cartSections(), sections_url: window.location.pathname });
    try {
      const r = await fetch(window.routes.cart_change_url, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body });
      const data = await r.json();
      if (!r.ok) throw new Error(data.description || data.message);
      HS.renderCart(data);
      publish(PUB_SUB_EVENTS.cartUpdate, { source: 'cart-items', cartData: data });
    } catch (e) {
      const m = this.querySelector('[data-cart-error]'); if (m) { m.textContent = e.message; m.hidden = false; }
    } finally { this.classList.remove('is-busy'); }
  }
  renderPage(html) { const inner = HS.sectionHTML(html, 'cart-items[data-page]'); if (inner !== null) this.innerHTML = inner; }
}
customElements.define('cart-items', CartItems);
class CartRemoveButton extends HTMLElement { }
customElements.define('cart-remove-button', CartRemoveButton);

/* Mengenfeld */
class QuantityInput extends HTMLElement {
  connectedCallback() {
    this.input = this.querySelector('input');
    this.querySelectorAll('button').forEach((b) => b.addEventListener('click', (e) => {
      e.preventDefault();
      const v = parseInt(this.input.value, 10) || 1;
      const min = parseInt(this.input.min, 10) || (this.input.dataset.index ? 0 : 1);
      this.input.value = b.name === 'plus' ? v + 1 : Math.max(min, v - 1);
      this.input.dispatchEvent(new Event('change', { bubbles: true }));
    }));
  }
}
customElements.define('quantity-input', QuantityInput);

/* Produktformular */
class ProductForm extends HTMLElement {
  connectedCallback() {
    this.form = this.querySelector('form');
    if (!this.form) return;
    this.btn = this.form.querySelector('[type="submit"]');
    this.form.addEventListener('submit', (e) => this.submit(e));
  }
  async submit(e) {
    e.preventDefault();
    if (this.btn && this.btn.getAttribute('aria-disabled') === 'true') return;
    const fd = new FormData(this.form);
    const fid = this.form.getAttribute('id') || '';
    const src = fid.includes('sticky') ? 'buybox_sticky' : (fid.endsWith('__main') ? 'buybox_haupt' : (this.dataset.source || 'product_form'));
    this.setBusy(true); this.error('');
    try { await HS.addToCart(fd, src); }
    catch (err) { this.error(err.message || (window.cartStrings && window.cartStrings.error) || 'Fehler'); publish(PUB_SUB_EVENTS.cartError, { source: 'product-form', message: err.message }); }
    finally { this.setBusy(false); }
  }
  setBusy(b) { if (this.btn) { this.btn.classList.toggle('is-busy', b); this.btn.setAttribute('aria-busy', b ? 'true' : 'false'); } }
  error(msg) { let m = this.querySelector('.product-form__error-message'); if (!m) { m = document.createElement('div'); m.className = 'product-form__error-message form__message form__message--error'; m.setAttribute('role', 'alert'); this.form.appendChild(m); } m.textContent = msg; m.hidden = !msg; }
}
customElements.define('product-form', ProductForm);

/* Fremde Bausteine (Synergie, Bundle) legen per Pub/Sub in den Warenkorb */
subscribe(PUB_SUB_EVENTS.cartAdd, (d) => { if (d && d.formData) HS.addToCart(d.formData, d.id || 'cartAdd').catch((e) => publish(PUB_SUB_EVENTS.cartError, { source: d.id, message: e.message })); });

/* Varianten-Fenster für Produktkarten („Auswählen“), wie Quick-Info im alten Theme.
   Holt /products/<handle>.js, zeigt Varianten als Kacheln, Menge und Kaufen-Knopf. */
const QuickAdd = {
  dlg: null,
  build() {
    const d = document.createElement('dialog');
    d.className = 'modal quick-add';
    d.setAttribute('aria-labelledby', 'QuickAddTitle');
    d.innerHTML = '<div class="quick-add__inner"><button type="button" class="icon-btn quick-add__close" data-close aria-label="Schließen"><svg class="ic" width="22" height="22" viewBox="0 0 24 24" aria-hidden="true"><path d="M6 6l12 12M18 6 6 18" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" fill="none"/></svg></button><div class="quick-add__body" aria-live="polite"></div></div>';
    document.body.appendChild(d);
    HS.watchDialog(d);
    this.dlg = d;
    return d;
  },
  esc(s) { const e = document.createElement('span'); e.textContent = s == null ? '' : String(s); return e.innerHTML; },
  async open(handle, url, source) {
    const d = this.dlg || this.build();
    const body = d.querySelector('.quick-add__body');
    body.innerHTML = '<p class="quick-add__loading">Wird geladen …</p>';
    d.showModal(); HS.lock(true);
    let p;
    try { const r = await fetch(`/products/${encodeURIComponent(handle)}.js`, { headers: { Accept: 'application/json' } }); if (!r.ok) throw 0; p = await r.json(); }
    catch (e) { window.location.href = url; return; }
    this.p = p; this.source = source;
    const title = String(p.title).split(' | ')[0];
    const img = p.featured_image ? `${p.featured_image}${p.featured_image.includes('?') ? '&' : '?'}width=400` : '';
    const first = p.variants.find((v) => v.available) || p.variants[0];
    const opts = p.options.map((o, oi) => {
      const name = typeof o === 'string' ? o : o.name;
      const values = typeof o === 'string' ? [...new Set(p.variants.map((v) => v.options[oi]))] : o.values;
      return `<fieldset class="quick-add__opt"><legend class="form__label">${this.esc(name)}</legend><div class="product-variant-options">${values.map((val, vi) => {
        const id = `qa-${oi}-${vi}`; const t = String(val); const parts = t.split(' - ');
        const label = parts.length > 1 ? `<b>${this.esc(parts[0])}</b><small>${this.esc(parts.slice(1).join(' - '))}</small>` : `<b>${this.esc(t)}</b>`;
        return `<input class="swatch-input__input" type="radio" id="${id}" name="qa-opt-${oi}" value="${this.esc(t)}"${first.options[oi] === t ? ' checked' : ''}><label class="swatch-input__label" for="${id}"><span class="variant-value">${label}</span></label>`;
      }).join('')}</div></fieldset>`;
    }).join('');
    body.innerHTML = `<div class="quick-add__head">${img ? `<img class="quick-add__img" src="${img}" alt="" width="200" height="200">` : ''}<div><h2 class="quick-add__title" id="QuickAddTitle">${this.esc(title)}</h2><div class="quick-add__price" data-qa-price></div><a class="quick-add__more" href="${this.esc(url)}">Alle Details ansehen</a></div></div>
      <form class="quick-add__form" novalidate>${p.variants.length > 1 ? opts : ''}
        <div class="quick-add__buy"><quantity-input class="quantity"><button type="button" class="quantity__button" name="minus" aria-label="Menge verringern"><svg class="ic" width="18" height="18" viewBox="0 0 24 24" aria-hidden="true"><path d="M5 12h14" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"/></svg></button><input class="quantity__input" type="number" name="quantity" min="1" value="1" inputmode="numeric" aria-label="Menge"><button type="button" class="quantity__button" name="plus" aria-label="Menge erhöhen"><svg class="ic" width="18" height="18" viewBox="0 0 24 24" aria-hidden="true"><path d="M12 5v14M5 12h14" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"/></svg></button></quantity-input>
        <button type="submit" class="btn btn--large quick-add__submit"><span>${this.esc((window.variantStrings && window.variantStrings.addToCart) || 'In den Warenkorb')}</span></button></div>
        <p class="form__message form__message--error" data-qa-error hidden role="alert"></p>
      </form>`;
    const form = body.querySelector('form');
    form.addEventListener('change', () => this.update());
    form.addEventListener('submit', (e) => { e.preventDefault(); this.add(); });
    this.update();
  },
  current() {
    const sel = this.p.options.map((o, oi) => { const c = this.dlg.querySelector(`input[name="qa-opt-${oi}"]:checked`); return c ? c.value : null; });
    return this.p.variants.length > 1 ? this.p.variants.find((v) => v.options.every((o, i) => o === sel[i])) : this.p.variants[0];
  },
  update() {
    const v = this.current();
    const pr = this.dlg.querySelector('[data-qa-price]');
    const btn = this.dlg.querySelector('.quick-add__submit');
    const s = window.variantStrings || {};
    if (!v) { pr.innerHTML = ''; btn.disabled = true; btn.firstChild.textContent = s.unavailable || 'Nicht verfügbar'; return; }
    const sale = v.compare_at_price && v.compare_at_price > v.price;
    pr.innerHTML = (sale ? `<s>${HS.money(v.compare_at_price)}</s> ` : '') + `<span>${HS.money(v.price)}</span><small>inkl. MwSt.</small>`;
    btn.disabled = !v.available;
    btn.firstChild.textContent = v.available ? (s.addToCart || 'In den Warenkorb') : (s.soldOut || 'Ausverkauft');
  },
  async add() {
    const v = this.current(); if (!v || !v.available) return;
    const btn = this.dlg.querySelector('.quick-add__submit');
    const fd = new FormData();
    fd.append('id', v.id);
    fd.append('quantity', Math.max(1, parseInt(this.dlg.querySelector('input[name="quantity"]').value, 10) || 1));
    btn.classList.add('is-busy'); btn.setAttribute('aria-busy', 'true');
    try { this.dlg.close(); await HS.addToCart(fd, this.source || 'karte_quick_add'); }
    catch (e) { this.dlg.showModal(); HS.lock(true); const m = this.dlg.querySelector('[data-qa-error]'); m.textContent = e.message; m.hidden = false; publish(PUB_SUB_EVENTS.cartError, { source: 'quick-add', message: e.message }); }
    finally { btn.classList.remove('is-busy'); btn.setAttribute('aria-busy', 'false'); }
  }
};
document.addEventListener('click', (e) => {
  const a = e.target.closest('[data-quick-add]');
  if (!a || e.ctrlKey || e.metaKey || e.shiftKey) return;
  e.preventDefault(); e.stopImmediatePropagation();
  QuickAdd.open(a.dataset.quickAdd, a.getAttribute('href'), a.dataset.source);
}, true);

/* Öffner für Drawer und Dialoge */
document.addEventListener('click', (e) => {
  const o = e.target.closest('[data-open]');
  if (!o) return;
  const t = document.querySelector(o.dataset.open);
  if (!t) return;
  e.preventDefault();
  if (t.open && typeof t.open === 'function' && !(t instanceof HTMLDialogElement)) t.open(o);
  else if (t instanceof HTMLDialogElement) { t.showModal(); }
});
document.addEventListener('click', (e) => { const c = e.target.closest('dialog [data-close]'); if (c) { c.closest('dialog').close(); HS.lock(false); } });
document.addEventListener('click', (e) => { const d = e.target.closest('dialog.modal'); if (d && e.target === d) { d.close(); HS.lock(false); } });

/* Bubble sofort aus dem letzten Stand (Cache-HTML ist leer) */
(function () {
  try {
    const n = parseInt(sessionStorage.getItem('hsCartCount') || '0', 10);
    const b = document.querySelector('#cart-icon-bubble .cart-count-bubble');
    if (b && n > 0 && !b.textContent.trim()) b.innerHTML = `<span aria-hidden="true">${n}</span><span class="visually-hidden">${n} Artikel</span>`;
  } catch (e) {}
})();

/* Ankündigungsleiste mobil: Claims rotieren */
(function () {
  const wrap = document.querySelector('.announcement__mob');
  if (!wrap || wrap.children.length < 2 || matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  let i = 0; const items = wrap.children;
  setInterval(() => { items[i].classList.remove('is-on'); i = (i + 1) % items.length; items[i].classList.add('is-on'); }, 6000);
})();

/* Chat-App (Buddy): Das geschlossene Fenster hat aria-hidden="true", seine Knöpfe bleiben aber per Tab erreichbar.
   inert folgt aria-hidden: zu = nicht fokussierbar, offen (aria-hidden="false") = normal. */
(function () {
  function sync(w) { w.inert = w.getAttribute('aria-hidden') === 'true'; }
  function hook(w) { sync(w); new MutationObserver(() => sync(w)).observe(w, { attributes: true, attributeFilter: ['aria-hidden'] }); }
  const w = document.getElementById('buddy-chat-window');
  if (w) return hook(w);
  const mo = new MutationObserver(() => { const el = document.getElementById('buddy-chat-window'); if (el) { mo.disconnect(); hook(el); } });
  mo.observe(document.documentElement, { childList: true, subtree: true });
  setTimeout(() => mo.disconnect(), 15000);
})();

/* Chat-App (Buddy): Das X am Rabatt-Pop-up hat in der App keinen Klick-Befehl (setupPopupClickHandlers ist leer).
   Hier schließt es das Pop-up. Die App merkt sich das Zeigen selbst (sessionStorage buddy_proactive_shown). */
document.addEventListener('click', (e) => {
  const x = e.target.closest && e.target.closest('#buddy-proactive-popup .buddy__popup-close');
  if (!x) return;
  const p = document.getElementById('buddy-proactive-popup');
  p.classList.add('hidden');
  p.setAttribute('aria-hidden', 'true');
});

document.addEventListener('DOMContentLoaded', () => publish(PUB_SUB_EVENTS.siteLoaded, { preventDefault() {} }));
